<div class="ui-g-12">
  <app-kontable
    #table
    title="{{ 'catalog.prizeCatalog' | translate }}"
    [columns]="[
      {field: 'id', title: 'ID'},
      {field: 'code', title: 'catalog.code'},
      {field: 'description', title: 'catalog.description'},
      {field: 'barcode_cont_pickup', title: 'catalog.barcodeContPickup'},
      {field: 'barcode_nocont_pickup', title: 'catalog.barcodeNocontPickup'},
      {field: 'flg_state', title: 'catalog.state'},
      {field: 'dt_start', title: 'catalog.dateStart', type: 'date', filterType: dateFilter},
      {field: 'dt_end', title: 'catalog.dateEnd', type: 'date', filterType: dateFilter}
    ]"
    [service]="catalogService"
    [paginationType]="paginationType"
    (onEdit)="editCatalog($event.id)"
    (onAdd)="addCatalog()"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="true"
    [showDeleteButton]="false"
    [showDetailsButton]="false"
    [showEditButton]="true"
    [showReport]="true"
    [additionalRowCommands]="customRow"
  >
    <ng-template #customRow data-testid="customRow" let-row>
      <!-- Lista premi Catalogo-->
      <p-button label="" pTooltip="{{ 'catalog.giftList' | translate }}" icon="fa fas fa-hashtag" styleClass="ui-button-info" (onClick)="goToGiftList(row)"></p-button>
      <!-- Cancella Catalogo-->
      <p-button *ngIf="row.operability == true" pTooltip="{{ 'common.delete' | translate }}" icon="fa far fa-trash"  styleClass="ui-button-info" (onClick)="deleteCatalog(row.id, table)"></p-button>
      <!-- Importa premi da excel nel catalogo-->
      <p-button *ngIf="row.operability == true" pTooltip="{{ 'catalog.importGift' | translate }}" icon="fa fa-upload" styleClass="ui-button-info" (onClick)="showDetail(row)"></p-button>
    </ng-template>
  </app-kontable>

  <p-dialog
        *ngIf="dialog"
        [(visible)]="dialog"
        [modal]="true"
        header="Importa gruppo di Articoli"
        [minWidth]="450"
        [draggable]="false"
        [resizable]="false"
        (onHide)="closeDialog()">

      <form id="gift-received-form" *ngIf="form" [formGroup]="form"
      [ngClass]="{'invalid-submit': invalidSubmit}">

      <div class="card">

        <!-- Catalog -->
        <div class="ui-g ui-fluid">
          <div class="ui-g-12 ui-md-12">
            <span class="label">{{ 'catalog.catalog' | translate }}</span>
            <input type="text" pInputText class="fieldInput" formControlName="catalog" disabled="true"/>
          </div>
        </div>
        <br><br>

        <!-- Gruppi Articoli -->
        <div class="ui-g ui-fluid">
          <div class="ui-g-12 ui-md-12">
            <span class="label">{{ 'catalog.articleImport' | translate}}</span><br>
            <p-dropdown
              [options]="catalogImportGift"
              formControlName="head"
              [autoWidth]="false"
              ></p-dropdown>
          </div>
        </div>
        <br><br>

        <!-- Checkbox Update-->
        <div class="ui-g ui-fluid">
          <div class="ui-g-12 ui-md-12">
            <span class="label">{{ 'catalog.checkboxImport' | translate}}</span><br><br>
            <p-checkbox formControlName="update" [binary]="true" [label]="checkboxLabel"></p-checkbox>
          </div>
        </div>
        <br>

        <!-- Button Importa Articoli -->
        <div class="ui-g">
          <div class="ui-g-12 ui-md-12">
            <button
            pButton
            icon="fa fa-plus-circle"
            iconPos="right"
            type="button"
            class="k-generic-btn"
            label="{{ 'catalog.importArticle' | translate }}"
            (click)="importArticle()"></button>
          </div>
        </div>

      </div>

      </form>

  </p-dialog>


</div>



// WEBPACK FOOTER //
// ./src/app/views/promotion/catalog/catalog.component.html